import { useHistory, useParams } from 'react-router-dom'

import MyBookingFormProperties from './MyBookingFormProperties'
import React from 'react'
import { components } from 'cng-web-lib'
import pathMap from 'src/paths/PathMap_FreightBooking'

const {
  form: { CngViewForm }
} = components

function MyBookingPage({ showNotification }) {
  const history = useHistory()

  function onSubmit(data) {
    console.log('submityyy', data)

    history.push('/')
    history.replace({ pathname: pathMap.MY_BOOKING, state: data })
  }

  return (
    // use CngViewForm here for customizable button set
    <CngViewForm
      fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
      history={history}
      showNotification={showNotification}
      bodySection={
        <MyBookingFormProperties.FormFields
          disabled={false}
          showNotification={showNotification}
        />
      }
      formikProps={{
        ...MyBookingFormProperties.formikProps,
        onSubmit: onSubmit
      }}
      // toClientDataFormat={PollingFormProperties.toClientDataFormat}
      // toServerDataFormat={PollingFormProperties.toServerDataFormat}
    />
  )
}

export default MyBookingPage
